<i18n src="./resources/locales.json"></i18n>
<template>
  <EcsUserIntroductionDialog width="720px" :show-dialog="showDialog" :title="title" @clickOutside="closeDialog">
    <template>
      <!-- eslint-disable vue/no-v-html -->
      <div v-if="content" class="embedded-content py-8" v-html="content"></div>
      <div v-else class="center-progress d-flex">
        <v-progress-circular class="m-auto" :size="50" color="primary" indeterminate></v-progress-circular>
      </div>
    </template>
    <template #actions>
      <v-btn color="primary" text @click="closeDialog">
        <span v-once>{{ $t('close') }}</span>
      </v-btn>
    </template>
  </EcsUserIntroductionDialog>
</template>

<script>
import EcsUserIntroductionDialog from '@/components/ecs-user-introduction/EcsUserIntroductionDialog';
import HelpService from '@/services/helpService';

export default {
  name: 'EcsReleaseNotes',

  components: { EcsUserIntroductionDialog },

  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      title: '',
      content: ''
    };
  },

  watch: {
    showDialog(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.getReleaseNotes();
      }
    }
  },

  created() {
    this.title = this.$t('releaseNotes.placeholder');
  },

  methods: {
    async getReleaseNotes() {
      const releaseVersion = process.env.APPLICATION_VERSION.replaceAll('.', '_')
        .replace(/(\+.*)?$/, '')
        .replace(/_[^_]*$/, '')
        .toLowerCase();
      try {
        const response = await HelpService.getReleaseNotes(releaseVersion);
        this.title = response.data.title;
        this.content = response.data.body.anonymous_export_view.value;
        this.content = this.content.replaceAll('<a ', '<a target="_blank" ');
      } catch (error) {
        this.title = this.$t('releaseNotes.error.title', { version: releaseVersion });
        this.content = this.$t('releaseNotes.error.content');
      }
    },
    closeDialog() {
      this.$emit('clickOutside');
    }
  }
};
</script>

<style scoped>
.center-progress {
  justify-content: center;
  align-items: center;
}
.embedded-content {
  line-height: 1.8;
}
</style>
